// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"0110bbd3","911":"66d2def8"}[chunkId] + ".chunk.css";
};